/**
 * MessageColorPicker — Spec utilisateur fork 25.42.
 * Sélecteur 4 couleurs (bleu / rouge / noir / vert) pour les messages
 * personnalisés (par-file et global). Visible dans le panneau de
 * paramétrage de la file ET dans la modale de saisie du message global.
 */
import React from "react";

const COLORS = [
  { id: "blue",  label: "Bleu",  hex: "#002FA7" },
  { id: "red",   label: "Rouge", hex: "#D72638" },
  { id: "black", label: "Noir",  hex: "#0A0A0A" },
  { id: "green", label: "Vert",  hex: "#0A7F2E" },
];

export const MESSAGE_COLOR_HEX = COLORS.reduce((acc, c) => ({ ...acc, [c.id]: c.hex }), {});

function MessageColorPicker({ value = "blue", onChange, testId = "message-color-picker" }) {
  return (
    <div className="mt-3" data-testid={testId}>
      <p className="text-[11px] uppercase tracking-wider font-bold text-subtle mb-1.5">
        Couleur du message
      </p>
      <div className="flex flex-wrap items-center gap-2">
        {COLORS.map((c) => {
          const selected = (value || "blue") === c.id;
          return (
            <button
              key={c.id}
              type="button"
              onClick={() => onChange?.(c.id)}
              title={c.label}
              aria-label={`Couleur ${c.label}`}
              className={`relative inline-flex items-center justify-center h-9 w-9 rounded-full border-2 transition-transform ${
                selected ? "border-ink scale-110" : "border-border hover:scale-105"
              }`}
              style={{ backgroundColor: c.hex }}
              data-testid={`${testId}-opt-${c.id}`}
            >
              {selected && (
                <span className="text-white text-sm" aria-hidden="true">✓</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default MessageColorPicker;
